export default "__VITE_ASSET__GSs7v6da__"